
import React from 'react'
import Constants from 'scripts/base/Constants'

class GenerateItem extends React.Component {
  renderClickable = (item) => {
    const {selected, onClick, children, showResults, hasEnded} = this.props
    const classSelected = selected ? 'selected' : ''
    if (showResults || hasEnded) return (children)

    return (
      <a href="javascript:;" onClick={() => onClick(item.id)} className={`soompi-poll-item-wrapper ${classSelected}`}>
        {this.renderOverlay()}
        {children}
      </a>
    )
  }

  renderOverlay = () => {
    const {selected, showResults, hasEnded} = this.props
    if (!selected || showResults || hasEnded) { return null }
    return (
      <div className={`overlay`}>
        <div className="svg-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/>
          </svg>
        </div>
      </div>
    )
  }

  render() {
    const {item, layout, showResults, hasEnded} = this.props
    const {Poll} = Constants
    const resultsClass = (showResults || hasEnded) ? 'results' : ''

    let colClasses = ''
    switch (layout) {
      case Poll.Layouts.TILED:
        colClasses = 'small-6 med-3'
        break
      default:
        colClasses = 'small-12 med-12'
    }
    colClasses = (showResults || hasEnded) ? 'small-12 med-12' : colClasses
    return (
      <li className={`soompi-poll-item col ${colClasses} ${resultsClass}`}>
        {this.renderClickable(item)}
      </li>
    )
  }
}

export default GenerateItem



// WEBPACK FOOTER //
// ./assets/js/components/embed/PollItem.jsx